import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { deleteCarouselVideo, CAROUSEL_QUERY_KEY } from "./api";

interface DeleteCarouselVideoParams {
  venuePageId: string;
  videoId: string;
}

/**
 * Hook to delete a video from the carousel
 */
export function useDeleteCarouselVideo(): UseMutationResult<
  { success: boolean },
  Error,
  DeleteCarouselVideoParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, videoId }: DeleteCarouselVideoParams) =>
      deleteCarouselVideo(venuePageId, videoId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
